/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Cancel_Msg_LastInputs */



/**
* | output |
* | --- |
* | "This is the last round: cancelling deletes it, with its seating and scores. It can't be restored." |
*
* @param {Rounds_Cancel_Msg_LastInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_cancel_msg_last = /** @type {((inputs?: Rounds_Cancel_Msg_LastInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Cancel_Msg_LastInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("C'est la dernière ronde : l'annuler la supprime, avec son placement et ses scores. Elle ne pourra pas être restaurée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Es la última ronda: anularla la borra, con sus mesas y resultados. No se podrá restaurar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("É a última rodada: cancelá-la a apaga, com mesas e resultados. Não poderá ser restaurada.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È l'ultimo round: annullarlo lo cancella, con posti e punteggi. Non si potrà ripristinare.")
	return /** @type {LocalizedString} */ ("This is the last round: cancelling deletes it, with its seating and scores. It can't be restored.")
});